import { render, staticRenderFns } from "./about_zq.vue?vue&type=template&id=c27de572&scoped=true&"
import script from "./about_zq.vue?vue&type=script&lang=js&"
export * from "./about_zq.vue?vue&type=script&lang=js&"
import style0 from "./about_zq.vue?vue&type=style&index=0&id=c27de572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27de572",
  null
  
)

export default component.exports